import { JSX } from 'react'

import logo from '../../assets/img/specialty.svg'

export const SpecialtyIcon = (): JSX.Element => {
  return <img src={logo} height="20" alt="specialty" id="specialtyIcon" />
}
